module.exports = __webpack_public_path__ + "img/20-3-n.fe471519.png";